import { Tooltip } from '@ibsys/kit';
import { FC } from 'react';
import type { RunStatus } from '@/entities/jobs';
import { RunCircleIcon } from './RunCircleIcon';
import { RUN_CIRCLE_STYLES } from './utils';

type RunResultCircleProps = {
  status: RunStatus;
};

// Финальный кружок с результатом пайплайна
export const RunResultCircle: FC<RunResultCircleProps> = ({ status }) => {
  const styles = RUN_CIRCLE_STYLES[status] ?? RUN_CIRCLE_STYLES.PENDING;
  const isRunning = status === 'RUNNING';

  return (
    <Tooltip tooltip={status}>
      <div
        className={`flex shrink-0 items-center justify-center size-6 rounded-full border-1 ${styles.bg} ${styles.border} ${styles.icon} ${isRunning ? 'animate-pulse' : ''}`}
      >
        <RunCircleIcon status={status} />
      </div>
    </Tooltip>
  );
};
